import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'

import _NativeDateWidget from 'react-jsonschema-form/lib/components/widgets/DateWidget'
import _NativeTextWidget from 'react-jsonschema-form/lib/components/widgets/TextWidget'
const supportsNativeDate = () => {
  var test = document.createElement('input')
  test.type = 'date'
  return test.type === 'date'
}

const TEST = false
const NativeDateWidget = TEST ? _NativeTextWidget : _NativeDateWidget

const pad = value => (value < 10 ? `0${value}` : `${value}`)

const today = () => {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

const toIso = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

const parseOffset = raw => {
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw

  if (typeof raw === 'string') {
    const trimmed = raw.trim()
    if (trimmed === '') return null
    if (/^-?\d+$/.test(trimmed)) {
      const numeric = Number(trimmed)
      return Number.isFinite(numeric) ? numeric : null
    }
    if (trimmed.toLowerCase() === 'today') return 0
    const match = /^today\s*([+-])\s*(\d+)\s*(?:d|day|days)?$/i.exec(trimmed)
    if (match) {
      const amount = parseInt(match[2], 10)
      if (!Number.isNaN(amount)) {
        return match[1] === '-' ? -amount : amount
      }
    }
  }

  return null
}

const resolveLimit = (schema, key, clamp) => {
  if (!schema) return {}

  const raw = schema[key]
  if (raw === undefined || raw === null || raw === '') return {}

  const offset = parseOffset(raw)
  if (offset !== null) {
    const base = today()
    base.setDate(base.getDate() + offset)
    return { date: base, value: toIso(base) }
  }

  const parsed = new Date(raw)
  if (!isNaN(parsed.getTime())) {
    const date = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
    return { date, value: toIso(date) }
  }

  return {}
}

const getLimits = schema => {
  const min = resolveLimit(schema, 'dynamicMinDate', 'min')
  const max = resolveLimit(schema, 'dynamicMaxDate', 'max')

  let minDate = min.date
  let maxDate = max.date
  let minValue = min.value
  let maxValue = max.value

  if (minDate && maxDate && minDate > maxDate) {
    minDate = maxDate
    minValue = maxValue
  }

  return { minDate, maxDate, minValue, maxValue }
}

export default class AltDateWidget extends Component {
  componentDidMount() {
    this.limits = getLimits(this.props.schema)

    if (TEST || !supportsNativeDate()) {
      const el = findDOMNode(this)
      console.log(el)
      this.jQueryInput = window.$(el)
      this.jQueryInput.datepicker({
        defaultDate: -1,
        dateFormat: 'dd.mm.yy',
        altFormat: 'yy-mm-dd',
        changeYear: true,
        minDate: this.limits.minDate || null,
        maxDate: this.limits.maxDate || null,
      })
    }

    this.applyLimitsToValue()
  }
  componentWillUnmount() {
    if (this.jQueryInput) {
      this.jQueryInput.datepicker('destroy')
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.schema !== this.props.schema) {
      this.limits = getLimits(this.props.schema)
      if (this.jQueryInput) {
        this.jQueryInput.datepicker('option', 'minDate', this.limits.minDate || null)
        this.jQueryInput.datepicker('option', 'maxDate', this.limits.maxDate || null)
      }
      this.applyLimitsToValue()
    }
  }
  applyLimitsToValue() {
    const { value, onChange } = this.props
    if (!onChange || !value) return

    const date = new Date(value)
    if (isNaN(date.getTime())) return

    const time = date.getTime()
    const { minDate, maxDate, minValue, maxValue } = this.limits || {}

    if (minDate && time < minDate.getTime()) {
      onChange(minValue)
      return
    }

    if (maxDate && time > maxDate.getTime()) {
      onChange(maxValue)
    }
  }
  render() {
    this.limits = this.limits || getLimits(this.props.schema)
    const props = this.props
    const extra = {}

    if (this.limits.minValue) extra.min = this.limits.minValue
    if (this.limits.maxValue) extra.max = this.limits.maxValue

    return <NativeDateWidget {...props} {...extra} />
  }
}
